import { createContext, useState, useEffect, useContext } from 'react';

//Hooks
import useWindowSize from '../utils/hooks/useWindowSize';

const SettingsContext = createContext({});

export const SettingsProvider = ({ children }) => {
  //Meta
  const [nonce, setNonce] = useState('');
  const nonceScript = document.querySelector('script[name="nonce"]').nonce;

  //UI
  const [navbar, setNavbar] = useState('');
  const { width, height } = useWindowSize();
  const [openMobileNotificationsMenu, setOpenMobileNotificationsMenu] =
    useState(false);
  const [windowSettingsSize, setWindowSettingsSize] = useState('desktop');
  const [openedDropdownMenuEl, setOpenedDropdownMenuEl] = useState();

  useEffect(() => {
    if (nonceScript) {
      setNonce(nonceScript);
    }
  }, [nonceScript]); ////set nonce, used by imageCropper

  useEffect(() => {
    if (width <= 320) {
      setWindowSettingsSize('phone--narrow');
    } else if (width <= 480) {
      setWindowSettingsSize('phone');
    } else if (width <= 1280) {
      setWindowSettingsSize('mobile');
    } else if (width < 1919) {
      setWindowSettingsSize('desktop--narrow');
    } else {
      setWindowSettingsSize('desktop');
    }
  }, [width]);

  return (
    <SettingsContext.Provider
      value={{
        nonce,
        height,
        width,
        navbar,
        openedDropdownMenuEl,
        setNavbar,
        setOpenedDropdownMenuEl,
        windowSettingsSize,
        openMobileNotificationsMenu,
        setOpenMobileNotificationsMenu,
      }}
    >
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => {
  return useContext(SettingsContext);
};
